import { boot } from 'quasar/wrappers';
import ga from './analytics';

export default boot(({ router }) => {
  router.afterEach((to) => {
    ga.logPage(to.path, to.name);
  });
});
